export enum JobInvoicingStatusType {
    Pending = 0,
    Approved = 1,
    Invoiced = 2,
}
